/**
 * Maps internal product keys to their display names.
 * @param type The internal product key (e.g., "post-injury", "baseline")
 * @returns The formatted display name (e.g., "Post-Injury Test")
 */
export function formatProductName(type: string) {
  switch (type) {
    case 'baseline':
      return 'Baseline Test';
    case 'post-injury':
      return 'Post-Injury Test';
    default:
      return type
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
  }
}
